import React from 'react';
import { Link } from 'react-router-dom';
import TemplateGallerySection from '../components/TemplateGallerySection';

export default function HomePage() {
  return (
    <div className="min-h-full flex flex-col">
      <div className="flex-1 flex flex-col items-center justify-center px-4 py-12">
        <div className="fluid-container text-center w-full">
          <h1 className="fluid-h1 font-bold text-white mb-6">
            Generate Anything
          </h1>
          <p className="fluid-subtitle text-white/70 mb-8">
            Unleash Your Creativity With AI
          </p>
          <div className="flex justify-center">
            <Link
              to="/image-to-video"
              className="bg-[#F9F7EA] text-[#0f1218] px-6 sm:px-8 py-3 min-h-[44px] rounded-button font-medium hover:bg-[#E7D7B1] transition-colors text-center flex items-center justify-center"
            >
              Image to Video
            </Link>
          </div>
        </div>
      </div>
      
      {/* Template Gallery Section - Show templates but hide controls */}
      <TemplateGallerySection hideControls={true} />
    </div>
  );
}

